import React, { FC } from 'react';

import usePageType from 'helpers/usePageType';
import SettingsButton from './SettingsButton';
import BackButton from './BackButton';
import OnboardingButton from './OnboardingButton';
import SavedPicksCloseButton from './SavedPicksCloseButton';

const LeftMenu: FC = () => {
  const { isDiscovery, isOnboarding, isExactlyProfile, isMyProfile, isSavedPicks } = usePageType();

  const isExactlyMyProfile = isMyProfile && isExactlyProfile;
  const showSettings = isExactlyMyProfile || isDiscovery;

  return (
    <>
      {isOnboarding && <OnboardingButton />}
      {isSavedPicks ? (
        <SavedPicksCloseButton />
      ) : (
        <>
          {showSettings && <SettingsButton />}
          {!showSettings && !isOnboarding && <BackButton />}
        </>
      )}
    </>
  );
};

export default LeftMenu;
